export default {
    getList: {
        default: [{
            create_at: "2018-12-04 01:08:07",
            license_end: "2018-12-06 01:08:07",
            id: 10,
            site_name: "玉环市第二人民医院",
            access_key: "VFYA97U08lZMCxQpadhOJoisDNz2RekS",
            sn: "ONEKEEPER201708140001"
        }, {
            create_at: "2018-12-03 08:00:33",
            license_end: "2018-12-06 01:08:07",
            id: 47,
            site_name: "天台县人力资源和社会保障局",
            access_key: "gVA92YkdbfcUaKt4QJpxi8GPXnu0wh3r",
            sn: "ONEKEEPER201708140002"
        }, {
            create_at: "2018-12-04 01:08:07",
            license_end: "2018-12-06 01:08:07",
            id: 10,
            site_name: "玉环市第二人民医院",
            access_key: "sKF3HU7tn1ZSwExjmC8BieQ2cX6boqrY",
            sn: "ONEKEEPER201708070001"
        }]
    }
}